"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoWithBoclipsProjectionFactory = exports.VideoFactory = void 0;
const LinkEntity_1 = require("../sub-clients/common/model/LinkEntity");
const PlaybackFactory_1 = require("./PlaybackFactory");
const CaptionStatus_1 = require("../sub-clients/videos/model/CaptionStatus");
class VideoFactory {
}
exports.VideoFactory = VideoFactory;
VideoFactory.sample = (video) => ({
    ...VideoFactory.defaultFields(),
    ...video,
});
VideoFactory.defaultFields = () => ({
    id: 'video-123',
    title: 'video title',
    description: 'video description',
    releasedOn: new Date(),
    playback: PlaybackFactory_1.PlaybackFactory.sample(),
    subjects: [],
    badges: [],
    legalRestrictions: '',
    ageRange: {},
    rating: 4,
    yourRating: undefined,
    bestFor: [],
    createdBy: '',
    language: { code: 'en-US', displayName: 'English (US)' },
    attachments: [],
    captionStatus: CaptionStatus_1.CaptionStatus.PROCESSING,
    type: 'INSTRUCTIONAL',
    taxonomy: {
        manual: { categories: [] },
        channel: { categories: [] },
    },
    links: {
        self: new LinkEntity_1.Link({ href: 'http://link-to-video' }),
        logInteraction: new LinkEntity_1.Link({ href: 'http://link-to-log-interaction' }),
        update: undefined,
    },
});
class VideoWithBoclipsProjectionFactory extends VideoFactory {
}
exports.VideoWithBoclipsProjectionFactory = VideoWithBoclipsProjectionFactory;
VideoWithBoclipsProjectionFactory.sample = (video) => ({
    ...VideoWithBoclipsProjectionFactory.defaultFields(),
    ...video,
});
VideoWithBoclipsProjectionFactory.defaultFields = () => ({
    ...VideoFactory.defaultFields(),
    channel: 'some content partner',
    channelId: 'partner-1',
    channelVideoId: 'video-id',
    type: 'INSTRUCTIONAL',
});
//# sourceMappingURL=VideosFactory.js.map